var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 16.25,
    r: 16.25,
    fill: "#ED1C00",
    fillOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98047 11.5627C8.98047 11.2238 9.16421 10.9116 9.46046 10.747L15.9928 7.11792C16.2746 6.96134 16.6173 6.96134 16.8992 7.11792L23.4315 10.747C23.7277 10.9116 23.9115 11.2238 23.9115 11.5627V15.8915C23.9115 19.2805 22.0741 22.4031 19.1115 24.049L16.8992 25.2781C16.6173 25.4347 16.2746 25.4347 15.9928 25.2781L13.7804 24.049C10.8178 22.4031 8.98047 19.2805 8.98047 15.8915V11.5627ZM19.0331 13.8366C19.3064 14.1099 19.3064 14.5531 19.0331 14.8264L17.5484 16.3111L19.0331 17.7958C19.3064 18.0691 19.3064 18.5123 19.0331 18.7856C18.7598 19.0589 18.3166 19.0589 18.0433 18.7856L16.5586 17.3009L15.0739 18.7856C14.8006 19.0589 14.3574 19.0589 14.0841 18.7856C13.8108 18.5122 13.8108 18.0691 14.0841 17.7958L15.5688 16.3111L14.0841 14.8264C13.8108 14.5531 13.8108 14.1099 14.0841 13.8366C14.3574 13.5633 14.8006 13.5633 15.0739 13.8366L16.5586 15.3213L18.0433 13.8366C18.3166 13.5633 18.7598 13.5633 19.0331 13.8366Z",
    fill: "#ED1C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationFailed);
export default __webpack_public_path__ + "static/media/verification-failed.028c8bed7df28be13d07dc467de11e07.svg";
export { ForwardRef as ReactComponent };